module.exports = __webpack_public_path__ + "static/media/Industry-Medium.239d398a.woff2";